import requestHelper from '@/utils/requestHelper'

/**
 * 已完成受访引导未录入公司名称的用户补录公司名称
 * @param data
 */
export function companyTagSave(data: any) {
  return requestHelper.post('v4/demand/guide/tag/company/save', data || {})
}
